import React, { useEffect, useState } from 'react';
import { PencilIcon, TrashIcon, PlayCircleIcon } from '@heroicons/react/24/solid';
import ConfigFormModal from './ConfigFormModal';
import './ConfigListModal.less';
import { Config } from '../../types/config';
import { useDispatch } from 'react-redux';
import { setActiveConfig } from '../../slices/configSlice';

interface Props {
    isOpen: boolean;
    onClose: () => void;
}

export default function ConfigListModal({ isOpen, onClose }: Props) {
    const [configs, setConfigs] = useState<Config[]>([]);
    const [editingConfig, setEditingConfig] = useState<Config | null>(null);
    const [showForm, setShowForm] = useState(false);
    const dispatch = useDispatch();

    const loadConfigs = async () => {
        const token = localStorage.getItem('userToken');
        const res = await fetch('/api/user/configs', {
            headers: { Authorization: `Bearer ${token}` }
        });
        const data = await res.json();
        setConfigs(data);
    };

    useEffect(() => {
        if (isOpen) loadConfigs();
    }, [isOpen]);

    const deleteConfig = async (id: string) => {
        const token = localStorage.getItem('userToken');
        await fetch(`/api/user/configs/${id}`, {
            method: 'DELETE',
            headers: { Authorization: `Bearer ${token}` }
        });
        loadConfigs();
    };

    if (!isOpen) return null;

    return (
        <>
            <div className="config-list-modal fixed inset-0 flex justify-center items-center z-50">
                <div className="config-list-wrapper p-6 rounded-lg w-full max-w-2xl">
                    <div className="flex justify-between items-center mb-4">
                        <h2 className="text-3xl font-bold">Meine Configs</h2>
                        <button className="button-close" onClick={onClose}>&times;</button>
                    </div>
                    <ul className="space-y-3">
                        {configs.map(config => (
                            <li key={config._id} className="flex justify-between items-center border p-3 rounded">
                                <span>{config.name}</span>
                                <div className="flex gap-2">
                                    <button onClick={() => { setEditingConfig(config); setShowForm(true); }}><PencilIcon className="w-4 h-4" /></button>
                                    <button onClick={() => deleteConfig(config._id)}><TrashIcon className="w-4 h-4" /></button>
                                    <button
                                        onClick={() => {
                                            dispatch(setActiveConfig(config));
                                            onClose();
                                        }}
                                    >
                                        <PlayCircleIcon className="text-green-600 w-8 h-8" />
                                    </button>
                                </div>
                            </li>
                        ))}
                    </ul>
                    <button
                        onClick={() => { setEditingConfig(null); setShowForm(true); }}
                        className="button mt-4 px-4 py-2 rounded"
                    >
                        Neue Config anlegen
                    </button>
                </div>
            </div>

            {showForm && (
                <ConfigFormModal
                    isOpen={showForm}
                    onClose={() => setShowForm(false)}
                    onSuccess={loadConfigs}
                    existing={editingConfig || undefined}
                />
            )}
        </>
    );
}
